// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d25b9797","488":"fe49025d"}[chunkId] + ".chunk.js";
};